import React from "react";
import { Box, Flex } from "@src/components/Boxes";
import { css } from "@emotion/react";
import { Text } from "@src/components/Text";
import Translate from "@src/components/translation/Translate";
import Img from "gatsby-image";
import { mediaQueries } from "@src/styles/theme";
import styled from "@emotion/styled";
import { graphql, useStaticQuery } from "gatsby";
import MarkedTranslate from "@src/components/translation/MarkedTranslate";

const Ul = styled("ul")`
  padding: 0 20px;
  margin-top: 0;
  margin-bottom: 11px;

  & > li {
    margin-bottom: 20px;
  }
`;

function FastFactsSection() {
  const data = useStaticQuery(graphql`
    query {
      hugging: file(name: { eq: "hugging-monsters@2x" }) {
        childImageSharp {
          fixed(width: 167, quality: 90) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
    }
  `);

  const { hugging } = data;
  return (
    <Box paddingBottom="60px" backgroundColor="transparent">
      <Flex
        flexWrap="wrap"
        padding="50px"
        backgroundColor="#fff"
        css={css`
          box-shadow: 0 2px 4px rgba(201, 201, 201, 0.5);
          border-radius: 5px;
          overflow: hidden;
        `}
      >
        <Flex width={["100%", "50%"]} flexDirection="column" px={[0, "15px"]}>
          <Ul>
            <MarkedTranslate path={`directus.page_press.facts_left`} />
          </Ul>
          <Flex justifyContent={["center", "left"]} marginBottom={["60px", 0]}>
            <Img fixed={hugging.childImageSharp.fixed} alt="ClassDojo characters hugging" />
          </Flex>
        </Flex>
        <Flex
          width={["100%", "50%"]}
          flexDirection="column"
          px="15px"
          paddingLeft={[0, "50px"]}
          css={css`
            ${mediaQueries[0]} {
              border-left: 1px solid #e8e8e8;
            }
          `}
        >
          {/*eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            href=""
            id="awards"
            className="anchor"
            css={css`
              display: block;
              height: 1px;
              position: relative;
              top: -88px;
              visibility: hidden;
            `}
          >
            <Translate path="pages.about_page.news_section.awards_title" />
          </a>
          <Ul>
            <MarkedTranslate path={`directus.page_press.facts_right`} />
          </Ul>
        </Flex>
      </Flex>
    </Box>
  );
}

export default FastFactsSection;
